/** @format */

import {ChartIds} from 'pages/Home/DigitalCast/models/chartIds';
import {Space} from 'pages/Home/DigitalCast/models/spaces';

interface Options {
  data: Space;
  removeId: ChartIds;
}

const removeMenuWidget = ({data, removeId}: Options) => {
  const {[removeId]: _removed, ...remainingWidgetsSettings} = data.widgetsSettings;

  return {
    ...data,
    widgetsBoardSelected: data.widgetsBoardSelected.filter(id => id !== removeId),
    widgetsMenuSelected: data.widgetsMenuSelected.filter(id => id !== removeId),
    widgetsSettings: remainingWidgetsSettings,
    chartSelected: {
      ...data.chartSelected,
      current: data.chartSelected.current.filter(id => id !== removeId),
      previous: data.chartSelected.previous.filter(id => id !== removeId),
    },
  };
};

export default removeMenuWidget;
